import React, { useEffect, useState, useRef } from 'react'
import Service from '../../services/videos';
import { TextField, TextArea, Button, Paper, CheckBox, IconButton } from '../ui/core';
import { Delete } from '../ui/coreIcons';
import FileUpload from './file-upload';
import Veditor from '../veditor/veditor';
import Settings from "../../AppSettings";
export default function Item({ item, onChange, onSave, canDelete }) {
    const locationAPI = Settings.getLocationAPI();
    const [contentRef] = useState(React.createRef());
    const ref = useRef()

    const handleChange = (ev) => {
        let tmpItem = Object.assign({}, item);
        tmpItem[ev.target.id] = ev.target.value || ev.target.checked;

        onChange(tmpItem);
    }

    const handleSave = (ev) => {
        let tmpItem = {};
        tmpItem[ev.target.id] = ev.target.value;
        tmpItem._id = item._id;
        onSave(tmpItem);
    }

    const handleSaveContent = () => {
        let tmpItem = {};
        tmpItem.content = contentRef.current.innerHTML;
        tmpItem._id = item._id;
        onSave(tmpItem);
    }

    const handleChangeAndSave = (attribute, value) => {
        let tmpItem = Object.assign({}, item);
        tmpItem[attribute] = value;
        onChange(tmpItem);

        let tmpItemSave = {};
        tmpItemSave._id = item._id;
        tmpItemSave[attribute] = value;
        onSave(tmpItemSave);
    }


    const handleDelete = () => {
        if (window.confirm("Weet u zeker dat u dit video item wilt verwijderen?")) {
            Service.remove(item)
                .then((result => {
                    let tmpItem = Object.assign({}, item);
                    tmpItem.active = false;
                    onChange(tmpItem);
                    onSave(tmpItem);
                }))
                .catch(ex => {
                    console.log(ex)
                })

        }
    }

    if (item && item.active === false) {
        return < div className="padding"><Paper className="padding">Dit video item is verwijderd</Paper></div>
    }

    return (
        <div >

            {item && < div className="padding">

                <Paper className="padding">

                    <CheckBox id="publish" label="Publiceren" checked={item.publish} onChange={(ev) => { handleChangeAndSave('publish', ev.target.checked) }} style={{ float: 'right' }} ></CheckBox>
                    <TextField id="title" label="Titel" value={item.title} onChange={handleChange} onBlur={handleSave}></TextField>
                    <FileUpload videoID={item._id} onFinished={() => { window.location.reload();}} />

                    <video width="720" height="405" controls>
                        <source src={`${locationAPI}videos/${item._id}/download`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                    <br style={{ clear: 'both' }} />  <br style={{ clear: 'both' }} />
                    <div className='label'>Uitleg</div>
                    <Veditor id="html-edit" value={item.content} contentRef={contentRef} files={[]} pages={[]} onSave={handleSaveContent}/>

                    <br style={{ clear: 'both' }} />
                    {canDelete && <Button style={{ float: 'right', backgroundColor: '#dd4e4e' }} onClick={() => { handleDelete() }}> verwijder item</Button>}

                    <br style={{ clear: 'both' }} />

                </Paper>
            </div>}
        </div>
    )
}
